import { MouseEvent } from 'react';
import classnames from 'classnames';
import Pill from '../pill/pill';
import type { WellBeingPillProps } from '../pill/pill';

import styles from './button.module.scss';

export type WellBeingButtonProps = WellBeingPillProps & {
  ariaLabel?: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  buttonStyle?: any; // contextStyle type,
  className?: string;
  disabled?: boolean;
  stopPropagation?: boolean;
  inputType?: 'button' | 'reset' | 'submit';
  dataType?: string;
  pillClassName?: string;
};

class WellBeingButton extends React.Component<WellBeingButtonProps> {
  constructor(props: WellBeingButtonProps) {
    super(props);
  }

  handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    const {
      isLoading,
      disabled,
      onClick,
      stopPropagation,
      inputType = 'button',
    } = this.props;

    if (disabled || isLoading || inputType !== 'button') return;

    if (stopPropagation) e.stopPropagation();

    if (onClick && typeof onClick === 'function') {
      onClick(e);
    }
  };

  render() {
    const {
      ariaLabel,
      buttonStyle,
      onMouseEnter,
      onMouseLeave,
      isActive,
      isLoading,
      pillStyle,
      className,
      pillClassName,
      disabled,
      inputType = 'button',
      dataType,
    } = this.props;

    return (
      <button
        aria-label={ariaLabel}
        className={classnames([styles.button, className])}
        style={context.handleStyle(buttonStyle)}
        onClick={this.handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        type={inputType}
        data-type={dataType}
        disabled={disabled}
      >
        <Pill
          padded={true}
          {...this.props}
          pillStyle={{ ...pillStyle }}
          clickable={disabled || isLoading ? false : true}
          isActive={isActive}
          className={classnames(styles['pill-override'], pillClassName)}
        />
      </button>
    );
  }
}

export default WellBeingButton;
